(function () {
  'use strict';

  var VERSION = '2.3.0';
  if (window.BNLatamHub && window.BNLatamHub.version === VERSION) {
    window.BNLatamHub.scan(document);
    return;
  }

  var instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root)) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = Array.prototype.slice.call(root.querySelectorAll('[data-bn-latam-reveal], [data-bn-latam-card]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bn-latam-card]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.bn-latam-hub__button'));
    var atlas = root.querySelector('.bn-latam-hub__atlas');
    var planetMap = root.querySelector('.bn-latam-hub__orbit-globe svg');
    var planetRing = root.querySelector('.bn-latam-hub__planet-ring');
    var observer = null;
    var atlasObserver = null;
    var visibilityObserver = null;
    var timers = new WeakMap();
    var motionAnimations = [];
    var atlasTimer = 0;
    var atlasBusy = false;

    instances.set(root, { destroy: destroy });

    root.dataset.alignMobile = root.dataset.alignMobile || root.getAttribute('data-align-mobile') || 'left';

    if (root.dataset.entryAnimation !== 'none' && 'IntersectionObserver' in window) {
      root.classList.add('bn-latam-motion-armed');
      root.classList.toggle('bn-latam-reduced-motion', reduced);
      revealItems.forEach(function (item) { item.classList.remove('is-revealed'); });
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            requestAnimationFrame(function () { entry.target.classList.add('is-revealed'); });
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { revealItems.forEach(function (item) { observer && observer.observe(item); }); });
      });
    } else {
      revealItems.forEach(function (item) { item.classList.add('is-revealed'); });
    }

    function pulse(target, className, duration) {
      if (!target) return;
      target.classList.remove(className);
      void target.offsetWidth;
      target.classList.add(className);
      var oldTimer = timers.get(target);
      if (oldTimer) window.clearTimeout(oldTimer);
      var timer = window.setTimeout(function () { target.classList.remove(className); }, duration);
      timers.set(target, timer);
    }

    function spinAtlas() {
      if (!atlas || atlasBusy) return;
      atlasBusy = true;
      atlas.classList.remove('is-spinning');
      void atlas.offsetWidth;
      atlas.classList.add('is-spinning');
      window.clearTimeout(atlasTimer);
      atlasTimer = window.setTimeout(function () {
        atlas.classList.remove('is-spinning');
        atlasBusy = false;
      }, reduced ? 1350 : 1020);
    }

    if (atlas) {
      atlas.addEventListener('pointerenter', function (event) {
        if (!event.pointerType || event.pointerType === 'mouse') spinAtlas();
      }, { signal: signal });
      atlas.addEventListener('pointerup', function (event) {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') spinAtlas();
      }, { signal: signal });
      if (!reduced && 'IntersectionObserver' in window) {
        atlasObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            window.setTimeout(spinAtlas, 420);
            atlasObserver.disconnect();
            atlasObserver = null;
          }
        }, { threshold: 0.55 });
        atlasObserver.observe(atlas);
      }
    }

    /* WAAPI hardening: avoids theme/browser CSS animation suppression on tablet/desktop. */
    if (Element.prototype.animate) {
      if (planetMap) {
        planetMap.style.animation = 'none';
        motionAnimations.push(planetMap.animate(
          [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }],
          { duration: reduced ? 46000 : 14000, iterations: Infinity, easing: 'linear' }
        ));
      }
      if (planetRing) {
        planetRing.style.animation = 'none';
        motionAnimations.push(planetRing.animate(
          [
            { transform: 'translateY(-50%) rotate(-16deg)', opacity: .76 },
            { transform: 'translateY(-50%) rotate(164deg)', opacity: 1 },
            { transform: 'translateY(-50%) rotate(344deg)', opacity: .76 }
          ],
          { duration: reduced ? 40000 : 14000, iterations: Infinity, easing: 'linear' }
        ));
      }
    }

    function setMotionState(active) {
      motionAnimations.forEach(function (animation) {
        try { active ? animation.play() : animation.pause(); } catch (error) {}
      });
    }
    if (motionAnimations.length && 'IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        setMotionState(entries.some(function (entry) { return entry.isIntersecting; }) && !document.hidden);
      }, { threshold: 0.03, rootMargin: '150px 0px 150px 0px' });
      visibilityObserver.observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) setMotionState(false);
      else if (!visibilityObserver) setMotionState(true);
    }, { signal: signal });

    root.addEventListener('pointerup', function (event) {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      var card = event.target.closest('[data-bn-latam-card]');
      if (card && root.dataset.cardInteraction !== 'none') pulse(card, 'is-interacted', 760);
      var button = event.target.closest('.bn-latam-hub__button');
      if (button) pulse(button, 'is-interacted', 720);
    }, { signal: signal });

    document.addEventListener('shopify:block:select', function (event) {
      var card = event.target && event.target.closest ? event.target.closest('[data-bn-latam-card]') : null;
      if (!card || !root.contains(card)) return;
      card.classList.add('is-revealed');
      pulse(card, 'is-interacted', 900);
    }, { signal: signal });

    function destroy() {
      if (observer) observer.disconnect();
      if (atlasObserver) atlasObserver.disconnect();
      if (visibilityObserver) visibilityObserver.disconnect();
      controller.abort();
      cards.concat(buttons).forEach(function (node) {
        var timer = timers.get(node);
        if (timer) window.clearTimeout(timer);
      });
      window.clearTimeout(atlasTimer);
      motionAnimations.forEach(function (animation) { try { animation.cancel(); } catch (error) {} });
      if (planetMap) planetMap.style.removeProperty('animation');
      if (planetRing) planetRing.style.removeProperty('animation');
      instances.delete(root);
    }
  }

  function scan(scope) {
    var base = scope || document;
    var roots = [];
    if (base.matches && base.matches('[data-bn-latam]')) roots.push(base);
    if (base.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(base.querySelectorAll('[data-bn-latam]')));
    roots.forEach(init);
  }

  function unload(scope) {
    if (!scope) return;
    var roots = [];
    if (scope.matches && scope.matches('[data-bn-latam]')) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-bn-latam]')));
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  window.BNLatamHub = { version: VERSION, scan: scan, unload: unload };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
})();
